import * as React from 'react';

const SummaryTitle = ({ children  })=>/*#__PURE__*/ React.createElement("strong", {
        className: "glasses-configurator-footer-prescription-column__title"
    }, children)
;

export { SummaryTitle };
//# sourceMappingURL=SummaryTitle.js.map
